module.exports = __webpack_public_path__ + "static/media/compare.4e9bc326.svg";